import { api } from './api';

interface AdminTokenValidationRequest {
  id_token: string;
  access_token: string;
  redirect_url?: string;
}

interface AdminTokenValidationResponse {
  success: boolean;
  redirect_url?: string;
  error?: string;
}

class AdminAuthService {
  async validateAzureToken(
    tokens: AdminTokenValidationRequest
  ): Promise<AdminTokenValidationResponse> {
    try {
      // Call auth backend, which will then call Django backend
      const response = await api.post<AdminTokenValidationResponse>(
        '/auth/admin/validate-azure-token',
        {
          id_token: tokens.id_token,
          access_token: tokens.access_token,
          redirect_url: tokens.redirect_url,
        },
        {
          withCredentials: true,
        }
      );

      return {
        success: true,
        redirect_url: response.data.redirect_url,
      };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to validate authentication token',
      };
    }
  }

  async logout(): Promise<void> {
    try {
      // Call logout endpoint if needed
      await api.post(
        '/auth/logout',
        {},
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      // Silently fail logout
    }
  }
}

export const adminAuthService = new AdminAuthService();
